import { useBucket } from '@mc/experiments-react'
import { useTranslation } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'

import { MONEY_BACK_PRICING_MICROCOPY_FLAG_NAME } from './useTrackPen5222Experiment'
import { MONEY_BACK_PRICING_MICROCOPY_I18N_NAMESPACE } from '../i18n'
import { useExperimentCriteria } from './useExperimentCriteria'

export const usePen5222AccessValueProp = (controlText: string): string => {
  const bucket = useBucket(MONEY_BACK_PRICING_MICROCOPY_FLAG_NAME)
  const { t } = useTranslation(MONEY_BACK_PRICING_MICROCOPY_I18N_NAMESPACE)
  const validExperimentCriteria = useExperimentCriteria()

  if (!validExperimentCriteria) return controlText

  if (bucket === 'variant_2') {
    return t('subscription.info.access', {
      instructors: getNumberOfInstructors(),
    })
  }

  return controlText
}
